import { connect } from 'react-redux';
import { CheckoutState } from '../../state';
import { ImplicitToSFooterDisclaimerProps } from './ImplicitToSFooterDisclaimer';

const _mapStateToProps = (
    _state: CheckoutState,
): Partial<ImplicitToSFooterDisclaimerProps> => ({
    locale: _state.app.locale,
});

const connectImplicitToSFooterDisclaimer = connect(_mapStateToProps);

export default connectImplicitToSFooterDisclaimer;
